import React from "react";
import { Section, Reveal, Eyebrow, SectionTitle } from "./ui";
import { bonuses } from "./data";
export function Bonuses() {
  return <Section id="bonos" className="bg-white" data-id="element-18" data-mp="pjg1tq2s8nvn">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-19" data-mp="avcvgfktva6b">
        <Eyebrow tone="green" data-id="element-20" data-mp="autfv5ingxvg">Recursos complementarios</Eyebrow>
        <SectionTitle data-id="element-21" data-mp="ft4ojcx7l2c3">3 recursos extra incluidos</SectionTitle>
        <p className="mt-4 text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-22" data-mp="1uet01q1fapu">
          Material complementario para sumar todavía más herramientas prácticas.
        </p>
      </Reveal>

      <div className="mt-8 grid gap-3 sm:mt-10 sm:grid-cols-3 sm:gap-5" data-id="element-23" data-mp="5tnnx9wtdemz">
        {bonuses.map((b, i) => <Reveal key={b.title} delay={i * 0.06} data-id="element-24" data-mp="3t0ogy264l9mo" data-mpi={i}>
            <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-[#dceee3] bg-white text-left shadow-[0_16px_44px_-30px_rgba(23,50,77,0.6)] sm:rounded-3xl" data-id="element-25" data-mp="3t1835v2t6k6i">
              <div className="relative flex items-center justify-center bg-[#f3f9f5] p-4 sm:p-6" data-id="element-26" data-mp="1r80dpsthem6w">
                <span className="absolute left-3 top-3 rounded-full bg-[var(--accent-green)] px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-27" data-mp="3id55b8gtp7bu">
                  Incluido
                </span>
                <img src={b.img} alt={b.title} className="h-36 w-auto rounded-lg object-contain drop-shadow-md sm:h-48" loading="lazy" data-id="element-28" data-mp="3r5ymxcjqsisv" />
              </div>
              <div className="flex flex-1 flex-col p-4 sm:p-5" data-id="element-29" data-mp="2ugr3ca2oojrl">
                <span className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-[var(--accent-green)]" data-id="element-30" data-mp="2uikadqh7l604">
                  {b.tag}
                </span>
                <h3 className="mt-0.5 font-serif-display text-base leading-tight text-[var(--ink)] sm:text-lg" data-id="element-31" data-mp="33ge2sqburfi0">
                  {b.title}
                </h3>
                <p className="mt-1.5 text-xs leading-snug text-[var(--muted)] sm:text-sm sm:leading-relaxed" data-id="element-32" data-mp="ir6tk0jpbk9w">
                  {b.desc}
                </p>
              </div>
            </article>
          </Reveal>)}
      </div>
    </Section>;
}